import React from 'react';
import Auxiliary from 'hoc/Auxiliary';
import Header from 'components/Header/Header';

export default function About() {
    return (
        <Auxiliary>
            <Header />
            <div className="container">
                <h1 className="display-4">About Trimble Cloud eXchange....</h1>
                <p className="lead"> Follows........</p>
                <div className="text-secondary"> Version 1.0.0 </div>
            </div>
        </Auxiliary>
    );
}
